try {
    // window._ = require('lodash');
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');
    // window.Cookies = require('js-cookie');


    /**
     * Reqires: NOTHING
     */
    window.Swiper = require("../../../node_modules/swiper/dist/js/swiper");

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    require('bootstrap');

    // require('../common/lib/_jQuery.extend');

    /**
     * requires:
     * - swiper
     */
    require('./wrappers/swiper');

    require('./lib/sticky-menu');
    require('./lib/url-manager');
    require('./lib/offers-counter');
    require('./lib/offers-search');
    require('./lib/offers-filters');
    require('./lib/cookies');
    require('./lib/analytics-manager');
} catch (e) {
}